<script lang="ts">
  // slot部分をモーダルウィンドウ化するコンポーネント
  import Dialog, { Title, Content } from "@smui/dialog";
  import Button, { Label } from "@smui/button";
  import { createEventDispatcher } from "svelte";

  export let open = false;
  export let title = "";
  export let btnLabel = "OK";
  export let closeButtonDisplay = false;
  export let closeBtnLabel = "Close";

  type AreaSize = "small" | "middle" | "large";
  export let size: AreaSize = "middle";

  let dialogWidth = "30";

  const dispatch = createEventDispatcher();

  const buttonClick = () => {
    open = !open;
    dispatch("buttonClick", true);
  };

  $: {
    if (size === "small") {
      dialogWidth = "20";
    } else if (size === "middle") {
      dialogWidth = "35";
    } else if (size === "large") {
      dialogWidth = "50";
    }
  }
</script>

<Dialog
  bind:open
  aria-labelledby="title"
  aria-describedby="content"
  surface$style={`width: ${dialogWidth}rem; max-width: calc(100vw - 5rem);`}
>
  <Title style="text-align: center;" id="title">{title}</Title>
  <Content id="content">
    <slot />
  </Content>
  <div class="pb-3" style="text-align:center;">
    {#if closeButtonDisplay}
      <Button
        on:click={() => {
          open = !open;
        }}
        style="background-color: #5f5f5f;"
        variant="raised"
      >
        <Label>{closeBtnLabel}</Label>
      </Button>
    {/if}
    <Button on:click={buttonClick} variant="raised">
      <Label>{btnLabel}</Label>
    </Button>
  </div>
</Dialog>
